import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './service-card.css'

const ServiceCard = (props) => {
  return (
    <div className={`service-card-service-card ${props.rootClassName} `}>
      <img
        alt={props.imageAlt}
        src={props.imageSrc}
        className="service-card-image"
      />
      <div className="service-card-container">
        <span className="service-card-heading service-card-title">
          {props.heading ?? (
            <Fragment>
              <span className="service-card-text2">Charging Service</span>
            </Fragment>
          )}
        </span>
        <span className="service-card-text1 service-card-description">
          {props.text ?? (
            <Fragment>
              <span className="service-card-text3">
                Charging with iCharge is simple, smart, and tailored to your
                everyday life.
              </span>
            </Fragment>
          )}
        </span>
        <Link
          to="/services"
          className="service-card-navlink button-primary button-medium thq-button-animated"
        >
          More
        </Link>
      </div>
    </div>
  )
}

ServiceCard.defaultProps = {
  imageAlt: 'image',
  heading: undefined,
  rootClassName: '',
  text: undefined,
  imageSrc: 'https://play.teleporthq.io/static/svg/default-img.svg',
}

ServiceCard.propTypes = {
  imageAlt: PropTypes.string,
  heading: PropTypes.element,
  rootClassName: PropTypes.string,
  text: PropTypes.element,
  imageSrc: PropTypes.string,
}

export default ServiceCard
